module.exports = __webpack_public_path__ + "static/img/game-logo@2x.bc5bd166.png";